<template>
  <div id="browserLockout"> 
    
      <div class="vo-card">
        <div class="icon">
          <v-icon large>mdi-alert-circle</v-icon>
        </div>
        <div class="title">BROWSER NOT SUPPORTED</div>

        <div class="context large">Your browser ({{ browser.name | camelToReadable }} v{{ browser.version }}) is not supported. Vilio supports the newest version of 
          <span class="link" v-for="(b, i) in browsers" :key="i" @click="openLink(b.link)">{{ b.name }}<span v-if="i === browsers.length - 2">, and </span><span v-else-if="i != browsers.length - 1">, </span><span v-else>.</span></span>
          Download a supported browser to use Vilio.
          <br><br>
          Select a browser below to be redirected to its download page.
        </div>

        <div style="text-align: center">
          <div class="browser" v-for="(b, key) in browsers" :key="key" @click="openLink(b.link)">
            <div class="logo" :style="{'backgroundImage': 'url(./assets/browserLogos/' + b.icon + ')'}"></div>
            <div class="name">{{ b.name }}</div>
            <!-- {{ browser.name }} -->
          </div>
        </div>

        <div class="context bottom">
          If you believe this is an error, please <a :href="contact" target="_blank">contact us</a> or use our <a :href="feedback" target="_blank">Feedback system</a>. 
        </div>

      </div>
    </div>

  </div>
</template>

<script>

  export default {

    data () {
      return {
        browsers: window.supportedBrowsers
      }
    },

    computed: {

      browser () {
        return window.browserDetect;
      },

      contact () {
        return window.urls.support;
      },

      feedback () {
        return window.urls.feedback.resident;
      }

    },

    methods: {

      openLink (link) {
        window.open(APP_URL + '/' + link, '_blank');
      }

    }
  }

</script>

<style lang="scss" scoped>

  @import '../css/global.scss';

  #browserLockout {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: $primary;
    @include scrollable();

    .vo-card {
      margin: 16px auto;
      padding: 16px;
      text-align: center;
      width: calc(100% - 32px);
      max-width: 700px;
    }

    .browser {
      display: inline-block;
      margin: 40px 8px 8px;
      cursor: pointer;
      
      .name {
        @include fontPrimary500;
        
        color: $primary;
        text-align: center;
        margin: 8px 0 0;
        text-transform: uppercase;
        user-select: none;
      }

      .logo {
  
        @include backgroundCenter();
        background-size: 75% 75%;
        margin: 0 auto;

        width: 125px;
        height: 125px;
      }

    }
    .icon {
      margin: 0 0 8px;
    }

    .title {
      @include fontPrimary500();
      @include title();

      font-size: 24px;
      color: $black54; 
      margin: 0 0 24px;
    }

    .context {
      font-size: 16px;
      color: $black54;

      &.bottom {
        margin: 24px 0 0;
        padding: 24px 0 8px;
        border-top: $borderBlack12;
      }
    }

    .link {
      color: $primary;
      cursor: pointer;
    }
    
  }

</style>


// WEBPACK FOOTER //
// src/components/BrowserLockout.vue